var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserInfo_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { userInfoSchema } from './jsonSchemas/userInfo';
import { userInfoSchemaValidation } from '../validations.generated';
export var USER_ATTRIBUTES;
(function (USER_ATTRIBUTES) {
    USER_ATTRIBUTES["SHOW_OBFUSCATE"] = "ShowObfuscate";
    USER_ATTRIBUTES["PII_AGREED"] = "PiiAgreed";
    USER_ATTRIBUTES["PII_DONT_SHOW"] = "PiiDontShow";
    // Tutorial
    USER_ATTRIBUTES["FINISHED_GET_STARTED_TUTORIAL"] = "FinishedGetStartedTutorial";
    USER_ATTRIBUTES["FINISHED_BASIC_TUTORIAL"] = "FinishedBasicTutorial";
    USER_ATTRIBUTES["FINISHED_VISUALIZE_TUTORIAL"] = "FinishedVisualizeTutorial";
    USER_ATTRIBUTES["FINISHED_PREDICT_TUTORIAL"] = "FinishedPredictTutorial";
    USER_ATTRIBUTES["FINISHED_IMPORT_DATA_TUTORIAL"] = "FinishedImportTutorial";
    USER_ATTRIBUTES["FINISHED_CLEAN_RETAIL_TUTORIAL"] = "FinishedCleanRetailTutorial";
    USER_ATTRIBUTES["FINISHED_DYNAMIC_DASHBOARD_TUTORIAL"] = "FinishedDynamicDashboardTutorial";
    USER_ATTRIBUTES["FINISHED_PROFIT_LOSS_TUTORIAL"] = "FinishedProfitLossTutorial";
    // Basic onboarding tooltip
    USER_ATTRIBUTES["ONBOARDING_TOOLTIP_DATASOURCE"] = "TutorialTooltipDatasource";
    USER_ATTRIBUTES["ONBOARDING_TOOLTIP_ROW_VIEWER"] = "TutorialTooltipRowViewer";
    USER_ATTRIBUTES["ONBOARDING_TOOLTIP_ADD_BUTTON"] = "TutorialTooltipAddButton";
    USER_ATTRIBUTES["ONBOARDING_TOOLTIP_BUILD_BUTTON"] = "TutorialTooltipBuildButton";
    // Next steps onboarding tooltip
    USER_ATTRIBUTES["ONBOARDING_SAW_REGRESSOR_CHART"] = "OnboardingSawRegressorChart";
    USER_ATTRIBUTES["ONBOARDING_SAW_REGRESSOR_PREDICT"] = "OnboardingSawRegressorPredict";
    USER_ATTRIBUTES["ONBOARDING_SAW_CLASSIFIER_PREDICT"] = "OnboardingSawClassifierPredict";
    USER_ATTRIBUTES["ONBOARDING_SAW_CLASSIFIER_UNDERLYING_DATA"] = "OnboardingSawClassifierUnderlyingData";
    USER_ATTRIBUTES["ONBOARDING_SAW_FORECAST_CHART"] = "OnboardingSawForecastChart";
    // RowViewer Stats alert
    USER_ATTRIBUTES["HIDE_ROWVIEWER_STATS_ALERT"] = "HideRowviewerStatsAlert";
    // Toggle Import success modal
    USER_ATTRIBUTES["HIDE_IMPORT_SUCCESS_MODAL"] = "HideImportSuccessModal";
    // PLG - Chatbot - chat with use menu
    USER_ATTRIBUTES["CHAT_WITH_US_MENU"] = "ChatWithUsMenu";
    // PLG - Checklist - checklist
    USER_ATTRIBUTES["CHECKLIST"] = "CheckList";
    // Update tool versioning modal - show modal on launch
    USER_ATTRIBUTES["SHOW_UPDATE_TOOL_VERSION_MODAL"] = "ShowUpdateToolVersionModal";
    // Notification Settings
    USER_ATTRIBUTES["NOTIFY_EXPORTS"] = "NotifyExports";
    USER_ATTRIBUTES["MANUAL_EXPORTS_SUCCESS"] = "ManualExportsSuccess";
    USER_ATTRIBUTES["MANUAL_EXPORTS_FAILURE"] = "ManualExportsFailure";
    USER_ATTRIBUTES["SCHEDULED_EXPORTS_SUCCESS"] = "ScheduledExportsSuccess";
    USER_ATTRIBUTES["SCHEDULED_EXPORTS_FAILURE"] = "ScheduledExportsFailure";
    // Assistant Settings
    USER_ATTRIBUTES["ASSISTANT_RESPONSE_SETTINGS"] = "AssistantResponseSettings";
})(USER_ATTRIBUTES || (USER_ATTRIBUTES = {}));
export var SignUpStatus;
(function (SignUpStatus) {
    SignUpStatus["CanLogin"] = "CanLogin";
    SignUpStatus["HasInvite"] = "HasInvite";
    SignUpStatus["NotConfirmed"] = "NotConfirmed";
    SignUpStatus["ShouldSignUp"] = "ShouldSignUp";
    SignUpStatus["CanGetTempOrg"] = "CanGetTempOrg";
    SignUpStatus["HasTempAccount"] = "HasTempAccount"; //  User has cognito record that belongs to the Temp group
})(SignUpStatus || (SignUpStatus = {}));
export var TempUserStatus;
(function (TempUserStatus) {
    TempUserStatus["ActiveUser"] = "ActiveUser";
    TempUserStatus["PasswordNotSet"] = "PasswordNotSet";
    TempUserStatus["NotVerified"] = "NotVerified";
    TempUserStatus["NotFound"] = "NotFound"; // no user found
})(TempUserStatus || (TempUserStatus = {}));
export var SignUpPage;
(function (SignUpPage) {
    SignUpPage["VerifyEmailUrl"] = "VerifyEmailUrl";
    SignUpPage["ConfirmUserCompleteForm"] = "ConfirmUserCompleteForm";
    SignUpPage["ConfirmUserVerifyForm"] = "ConfirmUserVerifyForm"; // Email Code Page
})(SignUpPage || (SignUpPage = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Unconfirmed"] = "UNCONFIRMED";
    UserStatus["Confirmed"] = "CONFIRMED";
    UserStatus["ExternalProvider"] = "EXTERNAL_PROVIDER";
    UserStatus["Unknown"] = "UNKNOWN";
    UserStatus["ResetRequired"] = "RESET_REQUIRED";
    UserStatus["ForceChangePassword"] = "FORCE_CHANGE_PASSWORD";
})(UserStatus || (UserStatus = {}));
let UserInfo = UserInfo_1 = class UserInfo {
    constructor(fullName, email, hash, userPlan) {
        this.fullName = fullName;
        this.email = email;
        this.hash = hash;
        this.userPlan = userPlan;
        JSON.validate(this, UserInfo_1);
    }
};
UserInfo = UserInfo_1 = __decorate([
    JsonSchemaV2(userInfoSchema, userInfoSchemaValidation)
], UserInfo);
export { UserInfo };
//# sourceMappingURL=userInfo.js.map